/* ============================================================
   HERZ DER KARTEN – product-gallery.js
   Galerie-Mechanik der Produktseite: geteilte Gesten-Werte, Consent-Gate fuer
   Fremdvideos, Lightbox (Track, Thumb-Leiste, Zoom/Pinch, FLIP-Morph),
   Mobile-Pager, Vorwaermen der 1600er-Derivate.

   Bis 2026-08-29 lag dieser Code als ~930-Zeilen-Inline-<script> in
   sections/main-product.liquid (Audit PERF-4 / TEST-2): er lief bei JEDEM
   Produktseiten-Aufruf ungecacht ueber die Leitung (~45 KB) und war wegen der
   Liquid-Ausgaben mitten im JS weder mit `node --check` noch vom CI-Gate
   scripts/theme-gates.js pruefbar. Im Liquid bleibt nur die Daten-Injection
   `window.__hdkImages`; diese Datei ist normales JS und damit gegated.

   Ladereihenfolge (layout/theme.liquid): product-gallery.js VOR product-page.js,
   beide `defer` — defer haelt die Quelltext-Reihenfolge ein. product-page.js
   liest window.__hdkGeste / __hdkVideoConsent / __hdkImages ohnehin nur
   innerhalb von Funktionen und haelt Fallbacks bereit.
   ============================================================ */
(function() {
  // ── Galerie-Daten aus Liquid ───────────────────────────────
  // Gesetzt vom Inline-Block in sections/main-product.liquid, der im Markup vor
  // diesem Asset steht. Je Eintrag: type, alt, u (EINE CDN-URL), w, h; bei
  // Videos zusaetzlich embed + sources.
  const images = window.__hdkImages || [];

  // ── Bild-Derivate aus EINER URL ────────────────────────────
  // Frueher trug jeder images-Eintrag dieselbe CDN-URL vierfach (240/360/800/
  // 1600 — nur der width-Parameter unterschied sich): bei 46 Medien ~19 KB reine
  // Wiederholung im HTML jeder Produktseite (Audit PERF-4b, 2026-08-29). Liquid
  // liefert jetzt eine URL, die Breiten entstehen hier. Muster wie `bildUrl()`
  // in sections/pokemon-kartenliste-suche.liquid; der replace-Zweig faengt den
  // Fall ab, dass die Quelle bereits ein width= traegt (Shopifys `image_url`
  // haengt es an) — sonst stuenden zwei width-Parameter in der URL.
  function bildUrl(u, breite) {
    if (!u) return '';
    return /[?&]width=\d+/.test(u)
      ? u.replace(/([?&])width=\d+/, '$1width=' + breite)
      : u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + breite;
  }

  let currentIndex = 0;

  // ── Geteilte Gesten-Werte (Hauptansicht + Lightbox + product-page.js) ──
  // EINE Wertequelle: getrennte Kopien in Haupt- und Lightbox-Geste drifteten
  // sonst auseinander (docs/galerie-track-wip.md). product-page.js liest sie
  // ueber window.__hdkGeste.
  const GESTE = {
    // Bildwechsel beim Loslassen: Strecke ODER Tempo (Cyre 2026-09-11, Clarity-
    // Befund «Wisch registriert nicht»). Vorher 0.28 der Breite und nur Strecke —
    // ein kurzer, schneller Flick blieb stehen. Werte s. decisions.md 2026-09-11.
    SNAP_ANTEIL: 0.18,             // Anteil der Bildbreite, ab dem gewechselt wird
    SNAP_MIN_PX: 40,               // px, Untergrenze der Strecken-Schwelle
    FLICK_TEMPO: 0.35,             // px/ms, ab denen ein kurzer Wisch als Flick zaehlt
    FLICK_MIN_PX: 20,              // px, Mindeststrecke eines Flicks (kein Zittern)
    FLICK_FENSTER: 100,            // ms, nur die juengste Bewegung bestimmt das Tempo
    START_SCHWELLE: 10,            // px, ab denen die Geste als horizontal gilt
    SNAP_MIN: 260, SNAP_MAX: 620,  // ms, Snap-Dauer skaliert mit der Reststrecke
    GUMMI: 0.28,                   // Nachgiebigkeit des Gummibands an den Enden
    EASING: 'cubic-bezier(0.22, 0.72, 0.24, 1)',
    ZU_INDEX_MS: 320,              // programmatische Wechsel (Thumb/Pfeil/Punkt)
  };
  window.__hdkGeste = GESTE;

  // ── Consent-Gate fuer Fremdvideos (SEC-1/ROB-4, 2026-08-29) ─────────────
  // YouTube-iframes setzen beim Laden Google-Cookies (~18 Monate). Pandectes
  // (Plus, kein Auto-Blocker) erreicht per JS erzeugte iframes strukturell
  // nicht — das Gate liegt darum im Theme: ohne Marketing-Consent baut die
  // Galerie statt des iframes eine Klick-zum-Laden-Flaeche (Zwei-Klick-
  // Loesung); der ausdrueckliche Klick gilt fuer den Rest der Seitenansicht
  // (__hdkVideoOk). Die Embed-Hosts sind serverseitig auf youtube-nocookie.com
  // umgeschrieben. product-page.js nutzt dasselbe Gate ueber
  // window.__hdkVideoConsent.
  window.__hdkVideoOk = false;
  function videoErlaubt() {
    if (window.__hdkVideoOk) return true;
    try {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && cp.marketingAllowed && cp.marketingAllowed());
    } catch (e) { return false; }
  }
  // baut die Klick-Flaeche: Poster + Play + Hinweistext; der Klick ersetzt
  // sie durch das Ergebnis von bauPlayer() (Element oder Fragment).
  function bauVideoConsent(m, bauPlayer) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'video-consent';
    if (m && m.u) {
      const img = document.createElement('img');
      img.className = 'video-consent__poster';
      img.src = bildUrl(m.u, 1200);
      img.alt = '';
      b.appendChild(img);
    }
    const play = document.createElement('span');
    play.className = 'video-consent__play';
    play.setAttribute('aria-hidden', 'true');
    const hint = document.createElement('span');
    hint.className = 'video-consent__hint';
    hint.textContent = (window.themeStrings && window.themeStrings.videoConsentHint) || 'Video laden';
    b.appendChild(play);
    b.appendChild(hint);
    b.addEventListener('click', function (ev) {
      // stopPropagation ist hier Pflicht (Befund M2.2-Verifikation 2026-08-29):
      // der Klick blubberte sonst zur Galerie-Hauptansicht durch, oeffnete die
      // Lightbox — und deren stoppeInlineMedien() raeumte den soeben
      // eingesetzten iframe sofort wieder ab (leerer Inline-Slide).
      ev.stopPropagation();
      ev.preventDefault();
      window.__hdkVideoOk = true;
      const parent = b.parentNode;
      const el = bauPlayer();
      if (parent && el) b.replaceWith(el);
      // Nach dem Consent-Klick direkt abspielen (Cyre 2026-08-29): ohne
      // autoplay=1 musste zweimal Play gedrueckt werden — einmal unsere
      // Flaeche, einmal YouTubes eigener Knopf. Der Klick ist die
      // User-Geste, Autoplay mit Ton ist damit browserseitig erlaubt.
      // Nur hier im Gate-Pfad; mit bestehendem Marketing-Consent laedt der
      // Player wie bisher ohne Autoplay beim Slide-Wechsel.
      const f = parent ? parent.querySelector('iframe') : null;
      if (f && f.src && !/[?&]autoplay=/.test(f.src)) {
        f.src += (f.src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
      }
    });
    return b;
  }
  window.__hdkVideoConsent = { erlaubt: videoErlaubt, gate: bauVideoConsent };

  // ── Elemente ──────────────────────────────────────────────
  const mainImg      = document.getElementById('gallery-main-img');
  const thumbBtns    = Array.from(document.querySelectorAll('.product-gallery__thumb'));
  const zoomBtn      = document.getElementById('gallery-zoom-btn');
  const lightbox     = document.getElementById('gallery-lightbox');
  const lightboxStage = document.querySelector('.gallery-lightbox__img-wrap');
  const lightboxTrack = document.getElementById('lightbox-track');
  const closeBtn     = document.getElementById('lightbox-close');
  const backdrop     = document.getElementById('lightbox-backdrop');
  const prevBtn      = document.getElementById('lightbox-prev');
  const nextBtn      = document.getElementById('lightbox-next');

  // Thumb-Klicks bindet product-page.js (setActiveThumb) — dieses Script besitzt
  // nur noch die Lightbox. Geteilte Wahrheitsquelle: mainImg.dataset.index.

  // Sichtbare Bilder = von der Varianten-Filterung (product-page.js blendet
  // Thumbs per display:none aus) uebrig gelassene. Die Lightbox navigiert NUR
  // darueber — andere Variantenbilder erscheinen im Zoom nicht mehr.
  function visibleIndices() {
    const vis = thumbBtns
      .filter(t => t.style.display !== 'none')
      .map(t => parseInt(t.dataset.index, 10));
    return vis.length ? vis : images.map((_, i) => i);
  }

  function currentMainIndex() {
    return mainImg ? (parseInt(mainImg.dataset.index, 10) || 0) : 0;
  }

  // Hauptansicht + aktiven Thumb synchronisieren (Lightbox-Navigation): ueber den Thumb-Klick,
  // damit die Bild/Video-Umschaltung aus product-page.js wiederverwendet wird.
  function syncGallery(idx) {
    const thumb = thumbBtns.find(t => parseInt(t.dataset.index, 10) === idx);
    if (thumb) thumb.click();
  }

  // ── Lightbox-Track: gleiche Mechanik wie die Hauptansicht (2026-08-07) ──
  // Ein Slide pro Medium, einmalig beim ersten Oeffnen gebaut. Bilder laden lazy
  // (data-full -> src im Ladefenster ±1); Videos zeigen ihr Poster und werden erst
  // auf dem aktiven Slide zum echten <video> (stoppt beim Verlassen Wiedergabe UND
  // Download). Sichtbarkeit spiegelt den Varianten-Filter der Thumbs.
  let lightboxSlides = null;
  let lightboxThumbBtns = null;
  const lightboxThumbs = document.getElementById('lightbox-thumbs');
  function bauLightboxSlides() {
    if (lightboxSlides) return;
    lightboxSlides = images.map(function (m, i) {
      const slide = document.createElement('div');
      slide.className = 'gallery-lightbox__slide';
      slide.dataset.index = i;
      if (m.type === 'image') {
        const img = document.createElement('img');
        img.className = 'gallery-lightbox__slide-img';
        img.alt = m.alt || '';
        img.dataset.full = bildUrl(m.u, 1600);
        slide.appendChild(img);
      } else {
        const box = document.createElement('div');
        box.className = 'gallery-lightbox__slide-media';
        slide.appendChild(box);
        zeigeVideoPoster(box, m);
      }
      lightboxTrack.appendChild(slide);
      return slide;
    });
    // Thumbnail-Leiste (nur Mobile sichtbar, CSS) — gleiche Indizes wie die Slides
    if (lightboxThumbs) {
      lightboxThumbBtns = images.map(function (m, i) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'gallery-lightbox__thumb';
        // Chase-Karten (main-product.liquid, `chase: true`): Hochformat-Scan ganz
        // zeigen statt mittig beschneiden — Modifier setzt contain + Weiss (CSS).
        if (m.chase) b.className += ' gallery-lightbox__thumb--chase';
        b.dataset.index = i;
        b.setAttribute('aria-label', m.alt || '');
        const img = document.createElement('img');
        // 240w-Basis + 360w-Derivat: die Thumbs rendern bis 108 CSS-px, auf
        // 2-3x-Displays also 216-324 Geraetepixel — 120w war dort sichtbar
        // unscharf (Cyre 2026-08-11).
        img.src = bildUrl(m.u, 240);
        // Retina-Schaerfe: Browser waehlt nach DPR x Anzeigegroesse (sizes = oberes
        // Ende der dynamischen Thumb-Skala, s. passeLightboxThumbsAn)
        if (m.u) {
          img.srcset = bildUrl(m.u, 240) + ' 240w, ' + bildUrl(m.u, 360) + ' 360w';
          img.sizes = '108px';
        }
        img.alt = '';
        img.loading = 'lazy';
        b.appendChild(img);
        lightboxThumbs.appendChild(b);
        return b;
      });
      lightboxThumbs.addEventListener('click', function (e) {
        const b = e.target.closest('.gallery-lightbox__thumb');
        if (!b) return;
        const idx = parseInt(b.dataset.index, 10);
        lightboxZuIndex(idx, true);
        syncGallery(idx);
      });
    }
  }

  // ── Mobile-Thumb-Groesse aus dem freien Weissraum der Buehne (Cyre 2026-08-11) ──
  // Die Leiste waechst nur, wo die Buehne Luft hat: Referenz ist das HOECHSTE
  // sichtbare Bild (Original-Ratio aus dem images-Array, Breite = Buehnenbreite,
  // object-fit: contain) — das darf durch das Wachstum NIE schrumpfen, LUFT bleibt
  // als Restabstand stehen. DECKEL haelt die Leiste im Thumb-Massstab (sonst wuerden
  // quadratische Bilder auf hohen Phones absurde Thumb-Groessen erlauben). Panel
  // waechst 1:1 mit dem Thumb (einzige variable Hoehe darin) -> die Basis-Buehne
  // laesst sich aus der aktuellen zurueckrechnen, die Funktion ist idempotent.
  // offsetHeight statt getBoundingClientRect: waehrend der Oeffnungs-Choreografie
  // steht die Buehne auf scale(0.955), Rect-Masse waeren ~4.5% zu klein.
  // Nur Mobile — die Desktop-Spalte fixiert ihre 84px-Thumbs per CSS.
  const lightboxDesktop = window.matchMedia('(min-width: 900px)');
  function passeLightboxThumbsAn() {
    if (!lightboxStage) return;
    if (lightboxDesktop.matches) { lightbox.style.removeProperty('--lb-thumb'); return; }
    const BASIS = 74, DECKEL = 108, LUFT = 32;   // Deckel 132 -> 108 (Cyre 2026-08-11: «etwas zu gross»)
    const aktuell = parseFloat(getComputedStyle(lightbox).getPropertyValue('--lb-thumb')) || BASIS;
    const stageBasis = lightboxStage.offsetHeight + (aktuell - BASIS);
    const breite = lightboxStage.offsetWidth;
    if (!stageBasis || !breite) return;
    let maxBild = 0;
    visibleIndices().forEach(function (i) {
      const m = images[i];
      const ratio = (m && m.w && m.h) ? m.h / m.w : 1;
      maxBild = Math.max(maxBild, Math.min(stageBasis, breite * ratio));
    });
    const ziel = Math.round(Math.max(BASIS, Math.min(DECKEL, BASIS + (stageBasis - LUFT - maxBild))));
    lightbox.style.setProperty('--lb-thumb', ziel + 'px');
  }
  window.addEventListener('resize', function () {
    if (lightbox.classList.contains('is-open')) passeLightboxThumbsAn();
  });

  // Aktiven Lightbox-Thumb markieren und in die Leiste scrollen (nur wenn die
  // Leiste gerendert ist — Desktop blendet sie aus, offsetParent ist dann null)
  function aktiviereLightboxThumb(idx) {
    if (!lightboxThumbBtns) return;
    let aktiv = null;
    lightboxThumbBtns.forEach(function (b) {
      const on = b.dataset.index === String(idx);
      b.classList.toggle('is-active', on);
      if (on) aktiv = b;
    });
    if (aktiv && aktiv.offsetParent) {
      aktiv.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    }
  }

  function ladeLightboxBild(slide) {
    if (!slide) return;
    const img = slide.querySelector('.gallery-lightbox__slide-img[data-full]');
    if (!img || img.getAttribute('src')) return;
    img.src = img.dataset.full;
    if (img.decode) img.decode().catch(function () {});
  }

  function sichtbareLightboxSlides() {
    return lightboxSlides ? lightboxSlides.filter(s => s.style.display !== 'none') : [];
  }
  function syncLightboxSlides() {
    const erlaubt = new Set(visibleIndices());
    lightboxSlides.forEach((s, i) => { s.style.display = erlaubt.has(i) ? '' : 'none'; });
    if (lightboxThumbBtns) {
      lightboxThumbBtns.forEach((b, i) => { b.style.display = erlaubt.has(i) ? '' : 'none'; });
    }
  }

  function zeigeVideoPoster(box, m) {
    box.innerHTML = '';
    if (m.u) {
      const img = document.createElement('img');
      img.className = 'gallery-lightbox__slide-img';
      img.src = bildUrl(m.u, 1200);
      img.alt = m.alt || '';
      box.appendChild(img);
    }
  }
  function bauLightboxVideo(m) {
    // Fremdvideo: iframe statt <video> — YouTube/Vimeo liefern keine Quell-Dateien.
    if (m.embed) {
      const bauIframe = function () {
        const f = document.createElement('iframe');
        f.src = m.embed;
        f.title = m.alt || '';
        f.loading = 'lazy';
        f.allow = 'accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen';
        f.allowFullscreen = true;
        f.referrerPolicy = 'strict-origin-when-cross-origin';
        f.setAttribute('frameborder', '0');
        // Echtes Seitenverhaeltnis -> der iframe deckt nicht die ganze Buehne,
        // links/rechts bzw. oben/unten bleibt Flaeche fuer die Wisch-Geste
        // (ein Cross-Origin-iframe verschluckt jeden Touch, s. product-page.css).
        if (m.ar) f.style.setProperty('--video-ar', m.ar);
        return f;
      };
      // Ohne Marketing-Consent erst die Klick-zum-Laden-Flaeche (SEC-1).
      if (!videoErlaubt()) return bauVideoConsent(m, bauIframe);
      return bauIframe();
    }
    // Kein embed UND keine Quell-Dateien -> es gaebe nur ein leeres <video> mit
    // Bedienleiste, das nie abspielt (ROB-9, 2026-08-29; trifft z.B. 3D-Modelle,
    // die als Nicht-Bild-Medium hier landen). null = Aufrufer laesst das Poster stehen.
    if (!m.sources || m.sources.length === 0) return null;
    const v = document.createElement('video');
    v.controls = true; v.autoplay = true; v.loop = false; v.playsInline = true; v.preload = 'metadata';
    if (m.u) v.poster = bildUrl(m.u, 1200);
    (m.sources || []).forEach(s => {
      const src = document.createElement('source');
      src.src = s.url;
      if (s.mime) src.type = s.mime;
      v.appendChild(src);
    });
    return v;
  }
  // Video nur auf dem aktiven Slide bauen (autoplay), sonst zurueck aufs Poster.
  // idx = -1 (schliessen) raeumt alle Videos ab.
  function aktiviereLightboxMedium(idx) {
    if (!lightboxSlides) return;
    lightboxSlides.forEach(function (slide, i) {
      const box = slide.querySelector('.gallery-lightbox__slide-media');
      if (!box) return;
      // 'video, iframe' deckt beide Player-Formen ab (gehostet / Fremdvideo);
      // der Rueckbau aufs Poster stoppt die Wiedergabe in beiden Faellen.
      if (i === idx) {
        if (!box.querySelector('video, iframe, .video-consent')) {
          // null = quellenloses Medium (ROB-9): Poster stehen lassen statt es durch
          // ein leeres <video> zu ersetzen.
          const player = bauLightboxVideo(images[i]);
          if (player) { box.innerHTML = ''; box.appendChild(player); }
        }
      } else if (box.querySelector('video, iframe, .video-consent')) {
        zeigeVideoPoster(box, images[i]);
      }
    });
  }

  // Pendant zu trackZuIndex (product-page.js): Track auf die Position des Mediums
  // schieben, Ladefenster ±1 nachziehen, Video/Zaehler nachfuehren.
  function lightboxZuIndex(idx, animiert) {
    if (morphZiel) beendeMorph(true);   // Navigation waehrend des Flugs bricht den Morph ab
    zoomZuruecksetzen(false);   // anderer Slide = frischer Blick, kein Rest-Zoom
    const slides = sichtbareLightboxSlides();
    const pos = Math.max(0, slides.findIndex(s => s.dataset.index === String(idx)));
    lightboxTrack.style.transition = animiert
      ? 'transform ' + GESTE.ZU_INDEX_MS + 'ms ' + GESTE.EASING
      : 'none';
    lightboxTrack.style.transform = 'translateX(' + (-pos * 100) + '%)';
    lightboxTrack.dataset.index = idx;
    currentIndex = idx;
    [pos - 1, pos, pos + 1].forEach(p => {
      if (p >= 0 && p < slides.length) ladeLightboxBild(slides[p]);
    });
    aktiviereLightboxMedium(idx);
    aktiviereLightboxThumb(idx);
  }

  // ── Oeffnungs-Morph (FLIP, Cyre 2026-08-08, Umbau nach gpt-5.6-Zweitmeinung):
  // Das ECHTE Lightbox-Bild fliegt selbst — inverse Transform an der Galerie-
  // Position, dann Transition auf neutral. KEIN Klon, KEINE Uebergabe: jeder
  // Layer-Tausch am Flugende (auch ein "im selben Frame" via offsetWidth-Reflow —
  // der erzwingt Layout, aber keinen Paint) rastert composited vs. layout auf
  // unterschiedliche Geraetepixel und war auf echten Geraeten (fraktionale DPR,
  // iPhone) als Mini-Drift sichtbar; Headless-Rect-Messungen sehen davon nichts.
  // Der neutrale End-Transform (translateZ(0)) BLEIBT stehen, solange der Slide
  // aktiv ist — sonst snappt die Ebenen-Rueckgabe an den Compositor erneut.
  // Voraussetzung ist das dekodierte Zielbild (identische Pixel von Frame 1);
  // darauf wird bis 300ms gewartet (decode ist dank Galerie-Preload praktisch
  // immer sofort da). Ohne Morph (reduced motion, Video-Slide, Ladeverzug)
  // greift die Fade/Scale-Choreografie.
  let morphZiel = null, morphTimer = null;
  const reduzierteBewegung = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Sichtbare Bildbox innerhalb einer Element-Box (object-fit: contain).
  // Seitenverhaeltnis kanonisch aus dem images-Array (Original-Masse) — die
  // CDN-Derivate runden Hoehen ganzzahlig und weichen minimal voneinander ab.
  function bildBox(img, rect, mediaIndex) {
    const m = images[mediaIndex];
    const a = (m && m.w && m.h) ? m.w / m.h : (img.naturalWidth || 1) / (img.naturalHeight || 1);
    let w = rect.width, h = w / a;
    if (h > rect.height) { h = rect.height; w = h * a; }
    return { left: rect.left + (rect.width - w) / 2, top: rect.top + (rect.height - h) / 2, width: w, height: h };
  }

  // erzwungen=true (Schliessen, Navigation, neue Geste): sofort neutralisieren,
  // Layer fallen lassen. Regulaeres Ende behaelt translateZ(0) — s. Kopfkommentar.
  function beendeMorph(erzwungen) {
    clearTimeout(morphTimer);
    lightbox.classList.remove('is-morph');
    const ziel = morphZiel;
    morphZiel = null;
    if (!ziel) return;
    ziel.style.visibility = '';
    ziel.style.transformOrigin = '';
    ziel.style.transition = '';
    ziel.style.transform = erzwungen ? '' : 'translateZ(0)';
  }

  function starteMorph() {
    const quelle = document.querySelector('#gallery-track .product-gallery__slide[data-index="' + currentMainIndex() + '"] .product-gallery__slide-img');
    if (!quelle || !quelle.complete || !quelle.naturalWidth) return;
    const ziel = zoomBild();   // nur Bild-Slides, Videos morphen nicht
    if (!ziel || !lightboxStage) return;
    const mediaIndex = currentMainIndex();

    morphZiel = ziel;
    ziel.style.visibility = 'hidden';   // bis zum Abflug nichts aufblitzen lassen

    let abgeflogen = false;
    const abflug = () => {
      if (abgeflogen || morphZiel !== ziel) return;
      abgeflogen = true;
      if (!lightbox.classList.contains('is-open')) { beendeMorph(true); return; }
      // Deadline verpasst (Bild laedt noch) -> kein Morph, Standard-Choreografie
      if (!(ziel.complete && ziel.naturalWidth > 0)) { beendeMorph(true); return; }

      // ERST is-morph setzen und rendern lassen, DANN messen: waehrend der
      // Einblende-Choreografie steht der Wrap noch auf scale(0.955) — zu frueh
      // gemessene Rechtecke sind ~4.5% zu klein (gemessen 2026-08-08).
      lightbox.classList.add('is-morph');
      void lightbox.offsetWidth;

      const von = bildBox(quelle, quelle.getBoundingClientRect(), mediaIndex);
      const zr = ziel.getBoundingClientRect();   // visibility:hidden hat Layout
      if (von.width < 10 || zr.width < 1) { beendeMorph(true); return; }

      // Inverser Start: Element-Box (Origin 0 0) exakt auf die Galerie-Bildbox
      ziel.style.transition = 'none';
      ziel.style.transformOrigin = '0 0';
      ziel.style.transform = 'translate(' + (von.left - zr.left) + 'px, ' + (von.top - zr.top) + 'px) scale(' + (von.width / zr.width) + ')';
      ziel.style.visibility = '';
      void ziel.offsetWidth;
      ziel.style.transition = 'transform 420ms cubic-bezier(0.22, 0.72, 0.24, 1)';
      ziel.style.transform = 'translate3d(0, 0, 0) scale(1)';
      ziel.addEventListener('transitionend', () => beendeMorph(false), { once: true });
      morphTimer = setTimeout(() => beendeMorph(false), 520);   // Fangnetz
    };

    if (ziel.complete && ziel.naturalWidth > 0) { abflug(); return; }
    morphTimer = setTimeout(abflug, 300);   // Deadline: laenger warten saehe traege aus
    if (ziel.decode) {
      ziel.decode().then(() => { clearTimeout(morphTimer); abflug(); })
        .catch(() => { clearTimeout(morphTimer); abflug(); });
    }
  }

  // ── Lightbox öffnen ───────────────────────────────────────
  // Beim Oeffnen der Lightbox laufende Inline-Player stoppen (ROB-3,
  // 2026-08-29): sonst spielten Inline- und Lightbox-Player gleichzeitig —
  // dieselbe Abraeumlogik wie setActiveThumb beim Slide-Wechsel (iframe kennt
  // keine pause()-API, gestoppt wird per DOM-Abbau; das <template> bleibt
  // stehen und baut den Player beim Rueckkehren neu).
  function stoppeInlineMedien() {
    document.querySelectorAll('#gallery-track .product-gallery__slide-media').forEach(function (box) {
      const tpl = box.querySelector('template[data-deferred-media]');
      const f = box.querySelector('iframe');
      if (f) { if (tpl) f.remove(); else f.src = f.src; }
      const v = box.querySelector('video');
      if (v) v.pause();
    });
  }

  function openLightbox() {
    if (!images.length) return;
    stoppeInlineMedien();
    bauLightboxSlides();
    syncLightboxSlides();
    // Preis der Desktop-Infozeile vom Produktseiten-Preis spiegeln (eine Wahrheits-
    // quelle; Variantenwechsel ist bei offener Lightbox nicht moeglich)
    const lbPrice = document.getElementById('lightbox-price');
    if (lbPrice) {
      const preis = document.querySelector('#price-wrap .price');
      lbPrice.textContent = preis ? preis.textContent.trim() : '';
      lbPrice.hidden = !preis;
    }
    // Gewaehlte Variante ("Blau") unter dem Titel — aus dem Varianten-Select
    // (Options-Text = lokalisierter Variantentitel)
    const lbVariant = document.getElementById('lightbox-variant');
    if (lbVariant) {
      const sel = document.getElementById('variant-select');
      const t = (sel && sel.selectedIndex >= 0) ? sel.options[sel.selectedIndex].text.trim() : '';
      const name = (t && t !== 'Default Title') ? t : '';
      lbVariant.textContent = name;
      lbVariant.hidden = !name;
    }
    lightbox.classList.add('is-open');   // vor lightboxZuIndex: die Thumb-Leiste braucht Layout fuers Hineinscrollen
    passeLightboxThumbsAn();   // vor Zentrierung/Morph: die Buehnen-Hoehe steht danach fest
    // Oeffnungs-Choreografie: Startzustand rendern lassen, dann Animationsklasse
    // (Reflow statt rAF — deterministisch vor dem naechsten Frame)
    lightbox.classList.remove('is-anim');
    void lightbox.offsetWidth;
    lightbox.classList.add('is-anim');
    lightbox.setAttribute('aria-hidden', 'false');
    lightboxZuIndex(currentMainIndex(), false);   // immer vom tatsaechlich angezeigten Bild starten
    document.body.style.overflow = 'hidden';
    // Fokus in den Dialog + Falle (window.modalFocus, theme.js)
    if (window.modalFocus) window.modalFocus.activate(lightbox);

    // Nav-Buttons nur zeigen, wenn die aktive Variante mehrere Bilder hat;
    // is-multi steuert den Weiterblaettern-Cursor auf den Bildern (CSS)
    const showNav = visibleIndices().length > 1;
    prevBtn.style.display = showNav ? '' : 'none';
    nextBtn.style.display = showNav ? '' : 'none';
    lightbox.classList.toggle('is-multi', showNav);

    // FLIP-Morph zum Schluss: erst NACH overflow:hidden messen (das Ausblenden
    // der Scrollbar verschiebt das Seitenlayout um ihre Breite)
    if (!reduzierteBewegung.matches) starteMorph();
  }

  function closeLightbox() {
    if (morphZiel) beendeMorph(true);
    lightbox.classList.remove('is-open');
    lightbox.classList.remove('is-anim');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    zoomZuruecksetzen(false);
    aktiviereLightboxMedium(-1);   // laufende Videos abraeumen
    if (window.modalFocus) window.modalFocus.deactivate();
  }

  // Navigation nur ueber die sichtbaren Bilder (Varianten-Filter wirkt im Zoom mit).
  // Pfeile/Tastatur duerfen umlaufen — wie die Galerie-Pfeile der Hauptansicht;
  // nur die Wisch-Geste endet am Track-Rand (Gummiband).
  function step(dir) {
    const vis = visibleIndices();
    if (vis.length < 2) return;
    let pos = vis.indexOf(currentIndex);
    pos = pos === -1 ? 0 : (pos + dir + vis.length) % vis.length;
    lightboxZuIndex(vis[pos], true);
    syncGallery(vis[pos]);
  }
  function showPrev() { step(-1); }
  function showNext() { step(1); }

  // ── Galerie-Pfeile (Hauptansicht, Desktop) ────────────────
  // Navigieren die sichtbaren Bilder direkt (via Thumb-Klick = syncGallery),
  // ohne die Lightbox zu oeffnen; stopPropagation, damit der Klick nicht als
  // Hauptbild-Klick durchschlaegt.
  const galPrev = document.getElementById('gallery-nav-prev');
  const galNext = document.getElementById('gallery-nav-next');
  function galleryStep(dir) {
    const vis = visibleIndices();
    if (vis.length < 2) return;
    let pos = vis.indexOf(currentMainIndex());
    pos = pos === -1 ? 0 : (pos + dir + vis.length) % vis.length;
    syncGallery(vis[pos]);
  }
  function updateGalleryNav() {
    const show = visibleIndices().length > 1;
    if (galPrev) galPrev.hidden = !show;
    if (galNext) galNext.hidden = !show;
  }
  if (galPrev && galNext) {
    galPrev.addEventListener('click', e => { e.stopPropagation(); galleryStep(-1); });
    galNext.addEventListener('click', e => { e.stopPropagation(); galleryStep(1); });
    updateGalleryNav();
    // Varianten-Wechsel blendet Thumbs per style um -> Pfeil-Sichtbarkeit nachfuehren
    const thumbsHost = document.querySelector('.product-gallery__thumbs');
    if (thumbsHost && 'MutationObserver' in window) {
      new MutationObserver(updateGalleryNav)
        .observe(thumbsHost, { attributes: true, subtree: true, attributeFilter: ['style'] });
    }
  }

  // ── Mobile-Pager: Positions-Punkte + Bildzahl statt Thumb-Leiste ──
  // Nur <600 sichtbar (CSS). Ein Punkt = ein SICHTBARES Bild (Varianten-Filter),
  // Klick springt an die Position; Quelle der Wahrheit bleibt die Thumb-Liste,
  // deshalb ein Observer auf ihre class/style-Aenderungen (deckt Thumb-Klick,
  // Swipe, Pfeile UND Varianten-Filter in einem ab, ohne in deren Code zu greifen).
  const pager = document.getElementById('gallery-pager');
  const dotsHost = document.getElementById('gallery-dots');
  const countEl = document.getElementById('gallery-count');
  if (pager && dotsHost && countEl) {
    function renderPager() {
      const vis = visibleIndices();
      // Auch bei EINEM Bild sichtbar (Cyre 2026-08-07): Varianten mit nur einem Bild
      // liessen den Pager sonst verschwinden und alles darunter sprang hoch. Ein
      // einzelner Punkt plus "1 Bild" haelt die Hoehe konstant.
      pager.hidden = vis.length < 1;
      if (pager.hidden) { dotsHost.innerHTML = ''; countEl.textContent = ''; return; }

      const active = vis.indexOf(currentMainIndex());
      if (dotsHost.children.length !== vis.length) {
        dotsHost.innerHTML = '';
        vis.forEach((mediaIndex, pos) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'product-gallery__dot';
          dot.dataset.index = mediaIndex;
          const label = (window.themeStrings && window.themeStrings.showImageN) || '';
          dot.setAttribute('aria-label', label.replace('__N__', pos + 1));
          dotsHost.appendChild(dot);
        });
      }
      Array.from(dotsHost.children).forEach((dot, pos) => {
        dot.classList.toggle('is-active', pos === active);
        dot.setAttribute('aria-current', pos === active ? 'true' : 'false');
      });
      const s = window.themeStrings || {};
      countEl.textContent = vis.length === 1
        ? (s.galleryCountOne || '')
        : (s.galleryCount || '').replace('__N__', vis.length);
    }

    dotsHost.addEventListener('click', e => {
      const dot = e.target.closest('.product-gallery__dot');
      if (dot) syncGallery(parseInt(dot.dataset.index, 10));
    });

    // Aktiven Punkt sofort setzen, ohne auf den Thumb-Zustand zu warten: Beim
    // Wisch-Wechsel laeuft erst die Snap-Animation und danach syncGallery — die
    // Punkte haetten sonst sichtbar Verzug (Cyre 2026-08-07).
    window.__galleryPagerAktiv = function (mediaIndex) {
      const vis = visibleIndices();
      const pos = vis.indexOf(mediaIndex);
      if (pos === -1) return;
      Array.from(dotsHost.children).forEach((dot, i) => {
        dot.classList.toggle('is-active', i === pos);
        dot.setAttribute('aria-current', i === pos ? 'true' : 'false');
      });
    };

    const thumbsHost = document.querySelector('.product-gallery__thumbs');
    if (thumbsHost && 'MutationObserver' in window) {
      new MutationObserver(renderPager)
        .observe(thumbsHost, { attributes: true, subtree: true, attributeFilter: ['style', 'class'] });
    }
    renderPager();
  }

  // ── Wisch-Geste: geteilte Track-Mechanik (Hauptansicht + Lightbox) ──
  // Der TRACK folgt dem Finger (Umbau 2026-08-07): Alle Slides liegen ohnehin
  // nebeneinander, bewegt wird nur ihr gemeinsamer Container. Damit gibt es keine
  // Beruehrungskante zwischen getrennt gerasterten Flaechen mehr — die iOS-Naht der
  // frueheren Klon-Loesung ist strukturell verschwunden (Zweitmeinung gpt-5.6: ein
  // gemeinsamer Track ist die robusteste Loesung, Klon-Ueberlappung nur der Notnagel).
  // Beim Loslassen entscheiden Strecke ODER Tempo (GESTE.SNAP_ANTEIL / FLICK_TEMPO):
  // ueber der Schwelle rastet die Galerie zum Nachbarn, darunter federt sie
  // zurueck — ein halb gezogenes Bild ist umkehrbar.
  //
  // EINE Implementation, ZWEI Instanzen (Hauptansicht + Lightbox, 2026-08-07):
  // Werte und Verhalten sind damit zwangslaeufig identisch — getrennte Kopien
  // drifteten sonst auseinander. Die Instanz-Unterschiede stecken in opt:
  //   slides()    sichtbare Slides (Varianten-Filter der jeweiligen Ansicht)
  //   ausnahme    Selektor, auf dem die Geste NICHT startet (Video-Controls)
  //   vorziehen   Ziel-Slide laden, sobald die Richtung feststeht
  //   snapStart   Anzeige sofort nachziehen (Pager-Punkte bzw. Zaehler)
  //   fertig      Zustand festschreiben, wenn der Snap steht
  //
  // KEIN Endlos-Umlauf (Cyre 2026-08-07, gebaut und wieder verworfen): Am ersten Bild
  // laesst sich nicht nach rechts ziehen, am letzten nicht nach links — der Track ist
  // dort schlicht zu Ende; das GUMMIBAND quittiert die Geste.
  //
  // UNTERBRECHBAR (Cyre 2026-08-07): Ein neuer Finger waehrend der laufenden
  // Snap-Animation bricht diese ab und zieht ab der aktuellen Position weiter —
  // vorher wurde der Touch geschluckt und schnelles Durchblaettern verschluckte
  // jeden zweiten Wisch. Eine Generationsnummer entwertet die Nachlauf-Timer der
  // abgebrochenen Geste.
  function trackGesteBinden(flaeche, track, opt) {
    const reduziert = window.matchMedia('(prefers-reduced-motion: reduce)');
    let gswX = 0, gswY = 0, gswActive = false, gswDid = false;
    let gswBreite = 0, gswBasis = 0, gswGeneration = 0;
    // Ziel einer noch laufenden Snap-Animation. Wird eine Geste mittendrin
    // uebernommen, ist dataset.index noch der ALTE Stand (er wird erst am Ende
    // geschrieben) — ohne dieses Zwischenziel zaehlte der zweite schnelle Wisch
    // vom alten Bild aus und man blieb faktisch stehen (Cyre 2026-08-07).
    let gswSchwebendesZiel = null;
    let gswStartPos = 0;
    let gswNachgezogen = false;   // Ziel-Slide dieser Geste schon angefordert?
    // Vertikale Geste (nur wo opt.wegwischen gesetzt ist: Lightbox). Die Achse
    // entscheidet sich EINMAL pro Geste und hier, in derselben Klassifikation
    // wie die horizontale — zwei getrennte Listener wuerden sich bei einem
    // schraegen Wisch gegenseitig ueberstimmen.
    let gswVert = false, gswVertGehabt = false, gswZeit = 0;
    // Bewegungsproben {x, t} der letzten FLICK_FENSTER ms fuer das Loslass-Tempo.
    // Das Tempo ueber die GANZE Geste (wie bei der Wegwisch-Geste) taugt hier
    // nicht: wer langsam anzieht und am Ende schnippt, hat ein hohes Endtempo
    // bei kleinem Mittel — und genau dieser Schnipp soll blaettern.
    let gswProben = [];

    function aktivePos() {
      const idx = String(track.dataset.index || 0);
      const p = opt.slides().findIndex(s => s.dataset.index === idx);
      return p === -1 ? 0 : p;
    }
    // Aktuelle Track-Verschiebung in px (auch mitten in einer laufenden Animation)
    function aktuellePx() {
      const m = new DOMMatrixReadOnly(getComputedStyle(track).transform);
      return m.m41;
    }
    function trackVerschieben(px, ms) {
      track.style.transition = ms
        ? 'transform ' + ms + 'ms ' + GESTE.EASING
        : 'none';
      track.style.transform = 'translateX(' + px + 'px)';
    }
    function probeMerken(x, t) {
      gswProben.push({ x: x, t: t });
      while (gswProben.length && t - gswProben[0].t > GESTE.FLICK_FENSTER) gswProben.shift();
    }
    // Loslass-Tempo in px/ms (Vorzeichen = Richtung) aus den Proben im Fenster.
    // Wer den Finger vor dem Heben still haelt, hat keine junge Probe mehr -> 0.
    function loslassTempo(x, t) {
      probeMerken(x, t);
      const erste = gswProben[0];
      const dt = t - erste.t;
      return dt < 8 ? 0 : (x - erste.x) / dt;
    }
    flaeche.addEventListener('touchstart', e => {
      if (e.touches.length !== 1
        || (opt.ausnahme && e.target.closest(opt.ausnahme))
        || (opt.gesperrt && opt.gesperrt())) { gswActive = false; return; }
      const slides = opt.slides();
      if (slides.length < 2) { gswActive = false; return; }

      // Laufende Snap-Animation uebernehmen statt den Touch zu verwerfen
      gswGeneration++;
      const laeuft = getComputedStyle(track).transitionDuration !== '0s';
      const px = aktuellePx();
      trackVerschieben(px, 0);   // Transition kappen, Position halten

      gswX = e.touches[0].clientX;
      gswY = e.touches[0].clientY;
      gswActive = true;
      gswDid = false;
      gswVert = false;
      gswZeit = performance.now();   // fuer die Flick-Erkennung der Wegwisch-Geste
      gswProben = [{ x: gswX, t: gswZeit }];
      gswNachgezogen = false;
      gswBreite = track.getBoundingClientRect().width || flaeche.getBoundingClientRect().width;
      gswBasis = px;   // tatsaechliche Pixelposition -> nahtloses Weiterziehen
      // Logische Ausgangsposition: bei Uebernahme das Ziel der abgebrochenen
      // Animation, sonst der festgeschriebene Zustand.
      gswStartPos = (laeuft && gswSchwebendesZiel !== null) ? gswSchwebendesZiel : aktivePos();
      if (!laeuft) gswSchwebendesZiel = null;
    }, { passive: true });

    flaeche.addEventListener('touchmove', e => {
      if (!gswActive) return;
      const dx = e.touches[0].clientX - gswX;
      const dy = e.touches[0].clientY - gswY;
      // Erste erkannte Richtung gewinnt und behaelt die Geste bis zum touchend.
      if (!gswDid && !gswVert) {
        if (Math.abs(dx) > GESTE.START_SCHWELLE && Math.abs(dx) > Math.abs(dy)) gswDid = true;
        else if (opt.wegwischen && Math.abs(dy) > GESTE.START_SCHWELLE && Math.abs(dy) > Math.abs(dx)) gswVert = true;
      }
      if (gswVert) {
        if (e.cancelable) e.preventDefault();
        gswVertGehabt = true;
        // Beide Achsen weitergeben: ist die Geste einmal als Wegwischen erkannt,
        // folgt das Bild dem Finger frei — seitlich blaettert es dann nicht mehr.
        opt.wegwischen.zieh(dx, dy);
        return;
      }
      if (!gswDid) return;
      probeMerken(e.touches[0].clientX, performance.now());
      // Ab erkannter Horizontal-Geste das vertikale Mitscrollen unterbinden (leicht
      // diagonale Finger scrollten sonst die Seite). Nur dieser eine Listener ist
      // passive:false — bis zur Klassifikation bleibt vertikales Scrollen nativ.
      if (e.cancelable) e.preventDefault();
      // An den Enden GUMMIBAND statt starrer Wand (Cyre 2026-08-07): Der Track gibt
      // ein Stueck nach und federt zurueck — das quittiert die Geste und sagt
      // zugleich "hier ist Schluss". Starr blockiert wirkte wie ein Aussetzer.
      const letzte = opt.slides().length - 1;
      let zug = dx;
      if ((gswStartPos === 0 && zug > 0) || (gswStartPos === letzte && zug < 0)) zug *= GESTE.GUMMI;
      trackVerschieben(gswBasis + zug, 0);
      // Das Bild, auf das zugezogen wird, vorziehen (Ladefenster nachschieben)
      if (!gswNachgezogen && Math.abs(dx) > 24) {
        gswNachgezogen = true;
        const ziel = opt.slides()[gswStartPos + (dx < 0 ? 1 : -1)];
        if (ziel && opt.vorziehen) opt.vorziehen(ziel);
      }
    }, { passive: false });

    flaeche.addEventListener('touchend', e => {
      if (!gswActive) return;
      gswActive = false;
      if (gswVert) {
        gswVert = false;
        const wdx = e.changedTouches[0].clientX - gswX;
        const wdy = e.changedTouches[0].clientY - gswY;
        const dauer = Math.max(1, performance.now() - gswZeit);
        // Entfernung und Tempo zaehlen zweidimensional — ein diagonaler Wurf
        // soll genauso ausloesen wie ein senkrechter.
        opt.wegwischen.los(wdx, wdy, Math.hypot(wdx, wdy) / dauer);
        return;
      }
      if (!gswDid) return;

      const meine = ++gswGeneration;
      const endX = e.changedTouches[0].clientX;
      const dx = endX - gswX;
      const slides = opt.slides();
      const pos = gswStartPos;   // beruecksichtigt ein uebernommenes Zwischenziel

      // Wechsel-Entscheid: ein Flick (junges Tempo ueber der Schwelle, in
      // Zugrichtung) blaettert auch nach kurzer Strecke; sonst entscheidet die
      // Strecke. Ein Flick GEGEN die Zugrichtung (angezogen, dann zurueckgeschnippt)
      // federt zum Ausgangsbild — auch wenn die Strecke schon ueber der Schwelle lag.
      const tempo = loslassTempo(endX, performance.now());
      const schwelle = Math.max(GESTE.SNAP_MIN_PX, gswBreite * GESTE.SNAP_ANTEIL);
      let richtung = 0;   // -1 = nach links gezogen (naechstes Bild), +1 = voriges
      if (Math.abs(tempo) >= GESTE.FLICK_TEMPO && Math.abs(dx) >= GESTE.FLICK_MIN_PX) {
        richtung = Math.sign(tempo) === Math.sign(dx) ? Math.sign(dx) : 0;
      } else if (Math.abs(dx) >= schwelle) {
        richtung = Math.sign(dx);
      }

      // Zielposition im Track — an den Enden bleibt es beim aktuellen Bild (kein Umlauf)
      let zielPos = pos;
      if (richtung < 0) zielPos = Math.min(pos + 1, slides.length - 1);
      else if (richtung > 0) zielPos = Math.max(pos - 1, 0);
      const zielPx = -zielPos * gswBreite;
      const zielSlide = slides[zielPos];

      const rest = Math.abs(zielPx - (gswBasis + dx));
      const anteil = Math.min(1, rest / (gswBreite || 1));
      const ms = reduziert.matches ? 0 : Math.round(GESTE.SNAP_MIN + (GESTE.SNAP_MAX - GESTE.SNAP_MIN) * anteil);
      requestAnimationFrame(() => trackVerschieben(zielPx, ms));

      const zielIdx = parseInt(zielSlide.dataset.index, 10);
      gswSchwebendesZiel = slides.indexOf(zielSlide);   // fuer eine evtl. Uebernahme
      // Anzeige sofort mitziehen (nicht erst nach der Animation)
      if (opt.snapStart) opt.snapStart(zielIdx);

      const fertig = () => {
        if (meine !== gswGeneration) return;   // Geste wurde inzwischen uebernommen
        gswSchwebendesZiel = null;
        opt.fertig(zielIdx);                   // Zustand + echte Track-Position (ohne Animation)
      };
      if (!ms) { fertig(); return; }
      let erledigt = false;
      const einmal = () => { if (erledigt) return; erledigt = true; fertig(); };
      track.addEventListener('transitionend', einmal, { once: true });
      setTimeout(einmal, ms + 90);
    }, { passive: true });

    flaeche.addEventListener('touchcancel', () => {
      if (gswVert) { gswVert = false; gswActive = false; opt.wegwischen.zurueck(); return; }
      if (!gswActive && !gswDid) return;
      gswActive = false;
      if (!gswDid) return;
      ++gswGeneration;
      gswSchwebendesZiel = null;
      requestAnimationFrame(() => trackVerschieben(-aktivePos() * gswBreite, GESTE.SNAP_MIN));
    }, { passive: true });

    // Klick nach echtem Wisch unterdruecken (Capture) — sonst feuert der
    // Klick-Handler der Flaeche (Lightbox oeffnen bzw. naechstes Bild) zusaetzlich.
    flaeche.addEventListener('click', e => {
      // Auch nach einer vertikalen Geste: der Klick auf das Bild blaettert sonst
      // weiter, obwohl der Finger gar nicht seitlich unterwegs war.
      if (gswDid || gswVertGehabt) {
        e.preventDefault(); e.stopPropagation();
        gswDid = false; gswVertGehabt = false;
      }
    }, true);
  }

  // Instanz 1: Hauptansicht. Zustandsquelle bleibt die Thumb-Liste (syncGallery),
  // damit Varianten-Filter, Pfeile, Pager und Lightbox unveraendert weiterlaufen.
  const galleryMain = document.getElementById('gallery-main');
  const galleryTrack = document.getElementById('gallery-track');
  if (galleryMain && galleryTrack) {
    trackGesteBinden(galleryMain, galleryTrack, {
      slides: () => Array.from(galleryTrack.querySelectorAll('.product-gallery__slide'))
        .filter(s => s.style.display !== 'none' && !s.dataset.loopKlon),
      ausnahme: 'video',
      vorziehen: s => { if (typeof window.__galerieSlideLaden === 'function') window.__galerieSlideLaden(s); },
      snapStart: idx => { if (typeof window.__galleryPagerAktiv === 'function') window.__galleryPagerAktiv(idx); },
      fertig: idx => syncGallery(idx),   // setzt Thumb + echte Track-Position
    });
  }

  // ── Wegwischen der Lightbox (vertikale Geste, Cyre 2026-08-30) ──────────
  // Nach oben oder unten wischen schliesst die Lightbox, wie man es von Social
  // Media kennt. Umbau vom selben Tag (Cyre): waehrend der Geste bewegt sich
  // NUR DAS BILD. Alles Umgebende — Thumb-Leiste samt Goldkante, die weisse
  // Flaeche ueber und unter dem Bild, der Schliessen-Knopf darin — blendet in
  // einem Zug aus, statt mitzuwandern. Das Bild schwebt danach frei ueber der
  // Seite. Vorgaenger-Fassungen (mitwandernde weisse Karte, an die Buehne
  // gekoppelter Knopf) sind damit hinfaellig, s. docs/decisions.md.
  //
  // Bewegt wird weiterhin die BUEHNE, nicht das <img> selbst: die Buehne
  // beschneidet ihren Inhalt (overflow: hidden, Voraussetzung des Slide-Tracks).
  // Ein im Rahmen verschobenes Bild liefe an dessen Kante an; verschiebt man den
  // Rahmen, wandert der Beschnitt mit. Weil die Buehne selbst nichts zeichnet,
  // ist das Bild das einzige, was man sich bewegen sieht.
  //
  // Die Achsen-Entscheidung liegt in trackGesteBinden (erste Richtung gewinnt);
  // gesperrt bei Bild-Zoom und ausgenommen ueber dem Panel — beide Regeln teilt
  // sie sich mit der horizontalen Geste, es gibt keine zweite Wahrheit.
  const WEG_BEZUG = 420;    // Bezugsstrecke der Verkleinerung
  // Verkleinerung progressiv: am Anfang kaum sichtbar, mit wachsender Entfernung
  // spuerbar schneller (Cyre 2026-08-30). Bei einer Geraden wirkte das Schrumpfen
  // ueber die kurzen, haeufigen Wege zu traege.
  const WEG_SKALA = 0.20, WEG_SKALA_KURVE = 1.35;
  const WEG_CHROME_MS = 150;   // Ausblendung des Umgebenden
  // Abdunkelung der dahinterliegenden Seite (Cyre 2026-08-30): Sobald die weisse
  // Flaeche weg ist, sieht man die Produktseite — anfangs stark abgedunkelt, und
  // je weiter das Bild wandert, desto mehr gibt sie den Blick frei. Die Geste
  // erzaehlt damit auch ohne Text, wohin sie fuehrt: je heller, desto naeher am
  // Verlassen. Getragen vom Wurzelelement des Dialogs, das unter der weissen
  // Flaeche liegt — kein zusaetzliches Markup noetig.
  // Eigene, KUERZERE Bezugsstrecke als die Verkleinerung und Endwert 0
  // (Cyre 2026-08-30): Beim schnellen Wegwischen endet die Geste nach kurzer
  // Strecke, die Abdunkelung stand also noch hoch — und das Schliessen loeschte
  // sie schlagartig. Dieser Sprung von leichter Daempfung auf gar keine las sich
  // wie ein Bildschirm, der aus dem Ruhezustand aufwacht. Jetzt ist sie schon bei
  // 240 px vollstaendig weg, und der Auswurf faehrt sie ohnehin auf 0 herunter:
  // beim Schliessen ist nichts mehr da, was springen koennte.
  const WEG_DUNKEL_MAX = 0.82, WEG_DUNKEL_MIN = 0, WEG_DUNKEL_BEZUG = 240;

  // Alles, was waehrend der Geste ausblendet — das Bild selbst ist NICHT dabei.
  // Eine Quelle fuer Ausblenden und Aufraeumen, damit die Liste nicht an zwei
  // Stellen driftet.
  function chromeTeile() {
    return [document.querySelector('.gallery-lightbox__side'), closeBtn, backdrop].filter(Boolean);
  }
  // pointer-events aus, solange es weg ist — unsichtbare Flaechen fangen sonst
  // weiter Tipps ab.
  function chromeSetzen(sichtbar) {
    const ms = reduzierteBewegung.matches ? 0 : WEG_CHROME_MS;
    chromeTeile().forEach(el => {
      el.style.transition = 'opacity ' + ms + 'ms ease';
      el.style.opacity = sichtbar ? '1' : '0';
      el.style.pointerEvents = sichtbar ? '' : 'none';
    });
  }
  function wegSetzen(dx, dy, ms) {
    if (!lightboxStage) return;
    // Bezug ist die zurueckgelegte STRECKE, nicht die Hoehe: das Bild laesst sich
    // frei umherschieben, und ein diagonaler Zug soll genauso weit "zaehlen".
    const strecke = Math.hypot(dx, dy);
    const skala = 1 - WEG_SKALA * Math.pow(Math.min(1, strecke / WEG_BEZUG), WEG_SKALA_KURVE);
    lightboxStage.style.transition = ms ? 'transform ' + ms + 'ms ' + GESTE.EASING : 'none';
    lightboxStage.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(' + skala + ')';
    if (lightbox) {
      const dunkel = WEG_DUNKEL_MAX
        - (WEG_DUNKEL_MAX - WEG_DUNKEL_MIN) * Math.min(1, strecke / WEG_DUNKEL_BEZUG);
      lightbox.style.transition = ms ? 'background-color ' + ms + 'ms ease' : 'none';
      lightbox.style.backgroundColor = 'rgba(0, 0, 0, ' + dunkel.toFixed(3) + ')';
    }
  }
  // Inline-Stile wieder abraeumen: darunter liegt die Oeffnungs-Choreografie
  // (is-anim -> transform:none), die sonst dauerhaft ueberschrieben bliebe.
  function wegAbraeumen() {
    if (lightbox) { lightbox.style.transition = ''; lightbox.style.backgroundColor = ''; }
    if (lightboxStage) { lightboxStage.style.transition = ''; lightboxStage.style.transform = ''; }
    chromeTeile().forEach(el => { el.style.transition = ''; el.style.opacity = ''; el.style.pointerEvents = ''; });
  }
  const wegwischen = {
    zieh: (dx, dy) => { chromeSetzen(false); wegSetzen(dx, dy, 0); },
    zurueck: () => {
      const ms = reduzierteBewegung.matches ? 0 : 220;
      chromeSetzen(true);
      wegSetzen(0, 0, ms);
      setTimeout(wegAbraeumen, ms + 40);
    },
    los: (dx, dy, tempo) => {
      // Entweder weit genug gezogen ODER schnell geschnippt — ein kurzer,
      // entschiedener Flick soll nicht an einer Streckenschwelle scheitern.
      const strecke = Math.hypot(dx, dy);
      const schwelle = Math.max(90, window.innerHeight * 0.16);
      if (strecke < schwelle && tempo < 0.55) { wegwischen.zurueck(); return; }
      // In DIE Richtung hinausfliegen, in die gezogen wurde — nicht senkrecht:
      // sonst knickt das Bild im letzten Moment aus der Wurfrichtung ab.
      const ms = reduzierteBewegung.matches ? 0 : 200;
      const laenge = strecke || 1;
      const weite = Math.max(window.innerWidth, window.innerHeight) * 0.95;
      wegSetzen(dx / laenge * weite, dy / laenge * weite, ms);
      setTimeout(() => { closeLightbox(); wegAbraeumen(); }, ms);
    },
  };

  // Instanz 2: Lightbox. fertig schreibt Track UND Hauptansicht fest (syncGallery),
  // damit beide nach dem Schliessen auf demselben Bild stehen.
  if (lightboxTrack) {
    trackGesteBinden(lightbox, lightboxTrack, {
      slides: sichtbareLightboxSlides,
      // Video-Controls UND das Seitenpanel ausnehmen (Thumb-Leiste scrollt selbst,
      // Info-Bereich gehoert nicht zur Bild-Geste). Ausgenommen ist gezielt das
      // <video> selbst, NICHT mehr die ganze .gallery-lightbox__slide-media-Box
      // (2026-08-30): die Box umfasst bei einem Fremdvideo auch die Streifen
      // neben dem iframe — dort soll gewischt werden koennen. Der iframe selbst
      // braucht keine Ausnahme, er verschluckt seine Touches ohnehin selbst.
      ausnahme: 'video, .gallery-lightbox__side',
      // Im gezoomten Bild pannt der Finger das Bild (Pinch-Zoom unten) — kein Wischen
      gesperrt: () => lightboxZoom.scale > 1,
      wegwischen: wegwischen,   // vertikale Geste schliesst die Lightbox
      vorziehen: ladeLightboxBild,
      snapStart: aktiviereLightboxThumb,   // Goldrahmen sofort mitziehen
      fertig: idx => { lightboxZuIndex(idx, false); syncGallery(idx); },
    });
  }

  // ── Pinch-Zoom in der Lightbox (Cyre 2026-08-08) ──────────
  // Nur das BILD skaliert (nicht die UI, anders als Safaris Seiten-Zoom):
  // Zwei-Finger-Pinch um den Fingermittelpunkt, Ein-Finger-Pan im gezoomten
  // Bild (die Track-Geste ist dann gesperrt, s. oben), Doppeltipp rein/raus.
  // Slide-Wechsel und Schliessen setzen den Zoom zurueck. Video-Slides sind
  // ausgenommen (zoomBild liefert nur Bild-Slides).
  const ZOOM_MAX = 4, ZOOM_DTAP = 2.5;
  const lightboxZoom = { scale: 1, x: 0, y: 0 };
  let zoomImg = null;
  let zoomResetTimer = null;

  function zoomBild() {
    const slides = sichtbareLightboxSlides();
    const aktiv = slides.find(s => s.dataset.index === String(lightboxTrack.dataset.index));
    return aktiv ? aktiv.querySelector('.gallery-lightbox__slide-img[data-full]') : null;
  }
  function zoomAnwenden(animiert) {
    if (!zoomImg) return;
    zoomImg.style.transition = animiert ? 'transform 200ms ease' : 'none';
    zoomImg.style.transform = 'translate(' + lightboxZoom.x + 'px, ' + lightboxZoom.y + 'px) scale(' + lightboxZoom.scale + ')';
  }
  // Pan begrenzen: das skalierte Bild wandert nie weiter, als es die Buehne fuellt
  function zoomKlemmen() {
    if (!zoomImg) return;
    const stage = lightboxStage.getBoundingClientRect();
    const maxX = Math.max(0, (zoomImg.offsetWidth * lightboxZoom.scale - stage.width) / 2);
    const maxY = Math.max(0, (zoomImg.offsetHeight * lightboxZoom.scale - stage.height) / 2);
    lightboxZoom.x = Math.min(maxX, Math.max(-maxX, lightboxZoom.x));
    lightboxZoom.y = Math.min(maxY, Math.max(-maxY, lightboxZoom.y));
  }
  function zoomZuruecksetzen(animiert) {
    lightboxZoom.scale = 1; lightboxZoom.x = 0; lightboxZoom.y = 0;
    if (!zoomImg) return;
    const img = zoomImg;
    zoomImg = null;
    clearTimeout(zoomResetTimer);
    if (animiert) {
      img.style.transition = 'transform 200ms ease';
      img.style.transform = 'translate(0px, 0px) scale(1)';
      // Transform nach der Animation ganz entfernen (kein Dauer-Layer auf iOS)
      zoomResetTimer = setTimeout(() => { img.style.transition = ''; img.style.transform = ''; }, 220);
    } else {
      img.style.transition = '';
      img.style.transform = '';
    }
  }
  if (lightboxStage) {
    let pinchStart = null;   // Zwei-Finger-Geste
    let panStart = null;     // Ein-Finger-Pan im gezoomten Bild
    let tapStartX = 0, tapStartY = 0;
    let letzterTap = { t: 0, x: 0, y: 0 };

    const stageMitte = () => {
      const r = lightboxStage.getBoundingClientRect();
      return { cx: r.left + r.width / 2, cy: r.top + r.height / 2 };
    };

    lightboxStage.addEventListener('touchstart', e => {
      if (e.touches.length === 2) {
        if (morphZiel) beendeMorph(true);   // Pinch bricht einen laufenden Morph ab
        const bild = zoomBild();
        if (!bild) { pinchStart = null; return; }
        zoomImg = bild;
        const a = e.touches[0], b = e.touches[1];
        const m = stageMitte();
        const mx = (a.clientX + b.clientX) / 2 - m.cx;
        const my = (a.clientY + b.clientY) / 2 - m.cy;
        pinchStart = {
          dist: Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY) || 1,
          scale: lightboxZoom.scale,
          // Bildpunkt (unskaliert, relativ Bildmitte) unter dem Fingermittelpunkt —
          // er bleibt waehrend des Pinchens unter den Fingern (Fokuspunkt-Zoom)
          px: (mx - lightboxZoom.x) / lightboxZoom.scale,
          py: (my - lightboxZoom.y) / lightboxZoom.scale,
        };
        panStart = null;
      } else if (e.touches.length === 1) {
        tapStartX = e.touches[0].clientX;
        tapStartY = e.touches[0].clientY;
        if (lightboxZoom.scale > 1) {
          panStart = { x: tapStartX, y: tapStartY, tx: lightboxZoom.x, ty: lightboxZoom.y };
        }
      }
    }, { passive: true });

    lightboxStage.addEventListener('touchmove', e => {
      if (pinchStart && e.touches.length === 2) {
        e.preventDefault();   // Browser-Seitenzoom unterbinden — wir zoomen selbst
        const a = e.touches[0], b = e.touches[1];
        const m = stageMitte();
        const mx = (a.clientX + b.clientX) / 2 - m.cx;
        const my = (a.clientY + b.clientY) / 2 - m.cy;
        const dist = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
        const s = Math.min(ZOOM_MAX, Math.max(1, pinchStart.scale * (dist / pinchStart.dist)));
        lightboxZoom.scale = s;
        lightboxZoom.x = mx - pinchStart.px * s;
        lightboxZoom.y = my - pinchStart.py * s;
        zoomKlemmen();
        zoomAnwenden(false);
      } else if (panStart && e.touches.length === 1 && lightboxZoom.scale > 1) {
        e.preventDefault();   // Pan gehoert dem Bild, nicht der Seite
        lightboxZoom.x = panStart.tx + (e.touches[0].clientX - panStart.x);
        lightboxZoom.y = panStart.ty + (e.touches[0].clientY - panStart.y);
        zoomKlemmen();
        zoomAnwenden(false);
      }
    }, { passive: false });

    lightboxStage.addEventListener('touchend', e => {
      if (pinchStart && e.touches.length < 2) {
        pinchStart = null;
        // Fast auf Ausgangsgroesse losgelassen -> sauber einrasten
        if (lightboxZoom.scale < 1.05) { zoomImg = zoomImg || zoomBild(); zoomZuruecksetzen(true); }
      }
      if (e.touches.length > 0) return;
      panStart = null;
      // Doppeltipp: zwei ruhige Tipps (<12px Bewegung) innert 300ms auf einem Bild-Slide
      const t = e.changedTouches[0];
      if (!t) return;
      const bewegt = Math.hypot(t.clientX - tapStartX, t.clientY - tapStartY) > 12;
      if (bewegt) { letzterTap.t = 0; return; }
      const jetzt = Date.now();
      const nah = Math.hypot(t.clientX - letzterTap.x, t.clientY - letzterTap.y) < 40;
      if (jetzt - letzterTap.t < 300 && nah) {
        letzterTap.t = 0;
        const bild = zoomBild();
        if (!bild) return;
        e.preventDefault();   // keinen Klick ausloesen (wuerde die Lightbox schliessen/weiterblaettern)
        zoomImg = bild;
        if (lightboxZoom.scale > 1) { zoomZuruecksetzen(true); return; }
        // Auf den Tipp-Punkt zoomen: der getippte Bildpunkt bleibt an Ort
        const m = stageMitte();
        lightboxZoom.scale = ZOOM_DTAP;
        lightboxZoom.x = (t.clientX - m.cx) * (1 - ZOOM_DTAP);
        lightboxZoom.y = (t.clientY - m.cy) * (1 - ZOOM_DTAP);
        zoomKlemmen();
        zoomAnwenden(true);
      } else {
        letzterTap = { t: jetzt, x: t.clientX, y: t.clientY };
      }
    }, { passive: false });
  }

  // ── Event Listener ────────────────────────────────────────
  if (zoomBtn) zoomBtn.addEventListener('click', openLightbox);
  // Klick auf die Hauptansicht oeffnet die Lightbox. Haengt am TRACK, nicht mehr am
  // frueheren Hauptbild (#gallery-main-img ist seit dem Track-Umbau nur noch ein
  // unsichtbarer Zustands-Anker). Video-Slides ausgenommen: dort gehoert der Klick
  // den Player-Controls. Nach einer Wisch-Geste unterdrueckt der Capture-Handler
  // den Klick bereits (gswDid).
  if (galleryTrack) {
    galleryTrack.addEventListener('click', e => {
      if (e.target.closest('.product-gallery__slide-media')) return;
      // Chase-Plakette (main-product.liquid) ist ein Link zur Kartenseite (neuer
      // Tab): der Klick gehoert dem Link, nicht der Lightbox.
      if (e.target.closest('.product-gallery__chase--link')) return;
      openLightbox();
    });
  }

  if (closeBtn)  closeBtn.addEventListener('click', closeLightbox);
  if (backdrop)  backdrop.addEventListener('click', closeLightbox);
  if (prevBtn)   prevBtn.addEventListener('click', showPrev);
  if (nextBtn)   nextBtn.addEventListener('click', showNext);

  // Klick im Lightbox-Track: aufs Bild -> naechstes (nur bei mehreren sichtbaren).
  // Die weisse Flaeche NEBEN dem Bild ist bewusst INERT (Cyre 2026-08-08):
  // geschlossen wird nur ueber X und Escape — ein knapp verfehltes Bild soll die
  // Lightbox nicht ungewollt schliessen. (Loest den Backdrop-Kontrakt von
  // 2026-07-29 ab; der galt der kleinen dunklen Buehne.)
  // Video-Slides gehoeren den Player-Controls. Nach einem echten Wisch
  // unterdrueckt der Capture-Handler der Geste den Klick.
  if (lightboxTrack) {
    lightboxTrack.addEventListener('click', e => {
      if (e.target.closest('.gallery-lightbox__slide-media')) return;
      if (e.target.closest('.gallery-lightbox__slide-img')) {
        // Bild-Klick blaettert nur auf Desktop weiter. Mobile: Einzeltipp tut
        // nichts (Wischen/Thumbs blaettern) — sonst wuerde der erste Tipp eines
        // Doppeltipps (= Zoom) bereits das Bild wechseln.
        if (window.matchMedia('(min-width: 900px)').matches && visibleIndices().length > 1) showNext();
      }
    });
  }

  // Keyboard-Navigation
  document.addEventListener('keydown', e => {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape')     closeLightbox();
    if (e.key === 'ArrowLeft')  showPrev();
    if (e.key === 'ArrowRight') showNext();
  });

  // (Der fruehere separate Lightbox-Swipe — diskreter prev/next ohne Mitziehen —
  // ist seit 2026-08-07 durch die geteilte Track-Geste oben ersetzt.)

  // ── Vorwaermen der Lightbox-Fulls (nur sichtbare Variante) ──
  // Zweck: Beim ersten Lightbox-Oeffnen/Weiterblaettern soll das 1600w-Bild
  // dekodiert bereitstehen (Morph-Deadline, kein Nachlade-Blitzer). Sobald
  // Galerie-Interaktion absehbar ist (Desktop Hover, Mobile erster Touch),
  // im Hintergrund holen — aber NUR die SICHTBAREN Bilder der aktiven Variante:
  // Galerie und Lightbox navigieren ausschliesslich darueber, unsichtbare
  // vorzuwaermen war reiner Ballast (Altfassung lud ALLE Fulls + ALLE Galerie-
  // Kandidaten ungefiltert: +3.3 MB beim ersten Touch auf einem 31-Bilder-
  // Produkt — gemessen 2026-08-09, Kern von Cyres Mobile-Langsamkeit).
  // Nur noch die FULLS: die Galerie-Kandidaten der sichtbaren Slides laedt
  // seit dem Track-Umbau das Ladefenster selbst (nach dem load-Event).
  // Set-basiert statt Einmal-Flag: nach einem Variantenwechsel waermt die
  // naechste Interaktion die neue Auswahl nach, Geladenes nie doppelt.
  // fetchPriority 'low' -> draengelt nicht vor regulaere Requests.
  const fullsVorgewaermt = new Set();
  function preloadVisibleFulls() {
    visibleIndices().forEach(function (i) {
      if (fullsVorgewaermt.has(i)) return;
      const m = images[i];
      if (!m || m.type !== 'image' || !m.u) return;
      fullsVorgewaermt.add(i);
      const img = new Image();
      img.fetchPriority = 'low';
      img.src = bildUrl(m.u, 1600);
    });
  }
  [document.querySelector('.product-gallery__thumbs'),
   document.querySelector('.product-gallery__main'),
   lightbox].forEach(function (el) {
    if (!el) return;
    // bewusst NICHT once: der Set-Guard ist billig, und nach Variantenwechsel
    // muss die naechste Beruehrung die neuen Sichtbaren nachziehen koennen
    el.addEventListener('mouseenter', preloadVisibleFulls);
    el.addEventListener('touchstart', preloadVisibleFulls, { passive: true });
  });


})();
